export default function initPartnershipTabs() {
    const partnershipTabsContainer = document.querySelector('.partnership-tabs');

    if (!partnershipTabsContainer) {
        return; // Exit if no partnership tabs container found
    }

    const tabButtons = partnershipTabsContainer.querySelectorAll('.partnership-tab-btn');
    const tabContents = partnershipTabsContainer.querySelectorAll('.partnership-tab-content');

    if (tabButtons.length === 0 || tabContents.length === 0) {
        console.warn('Partnership tabs: No tab buttons or content found');
        return;
    }

    // Function to set active tab
    const setActiveTab = (targetIndex) => {
        // Remove active classes from all buttons and content
        tabButtons.forEach((btn, index) => {
            btn.classList.remove('active', 'h5', 'md:after:block', 'max-md:border-b', 'max-md:border-b-3');
            btn.classList.add('p1', 'md:after:hidden');
        });

        tabContents.forEach((content, index) => {
            content.classList.remove('active');
            content.classList.add('hidden');
        });

        // Add active classes to target button and content
        if (tabButtons[targetIndex]) {
            tabButtons[targetIndex].classList.add('active', 'h5', 'md:after:block', 'max-md:border-b', 'max-md:border-b-3');
            tabButtons[targetIndex].classList.remove('p1', 'md:after:hidden');
        }

        if (tabContents[targetIndex]) {
            tabContents[targetIndex].classList.add('active');
            tabContents[targetIndex].classList.remove('hidden');
        }
    };

    // Add click event listeners to tab buttons
    tabButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const tabIndex = parseInt(button.getAttribute('data-tab'));
            setActiveTab(tabIndex);
        });

        // Add keyboard navigation support
        button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const tabIndex = parseInt(button.getAttribute('data-tab'));
                setActiveTab(tabIndex);
            }
        });
    });

    // Initialize with first tab active
    setActiveTab(0);

    // Add responsive behavior for mobile
    const handleResize = () => {
        const isMobile = window.innerWidth < 1024; // lg breakpoint

        if (isMobile) {
            // On mobile, ensure horizontal scrolling works smoothly
            const nav = partnershipTabsContainer.querySelector('nav');
            if (nav) {
                nav.style.scrollBehavior = 'smooth';
            }
        }
    };

    // Listen for resize events
    window.addEventListener('resize', handleResize);

    // Call once on load
    handleResize();
}
